/* eslint-disable */
import * as React from 'react';
import * as style from './ArticleLightView.css';
import { IContentItem, ContentTypes } from '../../types/content';
import { mergeStyles } from '@cian/utils';
import './froala.css';
import './quill.css';
import { removeAdfoxParams } from "./helpers/removeAdfoxParams";

export interface IArticleLightViewProps {
  contentItem?: IContentItem | null;
}

export const ArticleLightView: React.StatelessComponent<IArticleLightViewProps> = ({ contentItem }) => {
  if (!contentItem) {
    return (
      <div className={style['view']}>
        <h1 {...mergeStyles(style['title'], style['title_error'])}>Произошла ошибка при загрузке статьи</h1>
      </div>
    );
  }

  const { type, attributes: data } = contentItem;

  const { title, datePublish, subtitle, content, image } = data;

  const showSubtitle = subtitle && [ContentTypes.Articles, ContentTypes.Blog].includes(type);

  return (
    <div className={style['view']}>
      <h1 className={style['title']}>{title}</h1>
      <div className={style['info']}>
        <div className={style['date']}>{datePublish}</div>
      </div>
      <div className={style['content']}>
        {image && (
          <div className={style['image']}>
            <img src={image} alt={''} />
          </div>
        )}
        {showSubtitle ? (
          <div className={style['summary']} dangerouslySetInnerHTML={{ __html: subtitle }} />
        ) : (
          <div {...mergeStyles(style['summary'], style['summary_empty'])} />
        )}
        {content && (
          <div {...mergeStyles(style['html-content'], 'fr-view')} dangerouslySetInnerHTML={{ __html: removeAdfoxParams(content) }} />
        )}
      </div>
    </div>
  );
};
